<template>
  <div class="toast-layer" data-pw-test-id="toast-message" :class="{ inMicroFrontend: isMicroFrontend, isMobile: isMobile }">
    <c-toast
      v-for="toastMessage in uniqueToastMessages"
      :key="`${toastMessage.intent ?? ''}:${toastMessage.message}`"
      :intent="toCoppiIntent(toastMessage.intent)"
      @close="$emit('close-toast', toastMessage)"
      :message="toastMessage.message"
      class="c-layer-overlay"
      :action-button-label="toastMessage.actionLabel"
      @handle-action="toastMessage.handleAction?.()"
    />
  </div>
</template>

<script setup lang="ts">
  import { CToast, CoppiIntents } from '@bookingkit/coppi';
  import { defineProps, defineEmits, computed } from 'vue';
  import type { ToastMessage } from '@/components/Toasts/IUseToasts';

  const props = defineProps<{
    toastMessages: ToastMessage[];
    isMicroFrontend: boolean;
    isMobile: boolean;
  }>();

  const toCoppiIntent = (
    s?: string
  ): CoppiIntents.info | CoppiIntents.warning | CoppiIntents.success | CoppiIntents.critical | undefined => {
    switch (s) {
      case 'info':
        return CoppiIntents.info;
      case 'warning':
        return CoppiIntents.warning;
      case 'success':
        return CoppiIntents.success;
      case 'critical':
        return CoppiIntents.critical;
      default:
        return undefined;
    }
  };

  const uniqueToastMessages = computed(() =>
    props.toastMessages.reduce((acc, current) => {
      const exists = acc.some(item => item.message === current.message && item.intent === current.intent);
      return exists ? acc : acc.concat([current]);
    }, [] as ToastMessage[])
  );

  const $emit = defineEmits(['close-toast']);
</script>

<style scoped>
  .toast-layer {
    position: fixed;
    top: var(--s15);
    right: calc(50%);
    transform: translateX(+50%);
  }

  .toast-layer.inMicroFrontend,
  .toast-layer.isMobile {
    right: 50%;
  }

  .toast-layer.isMobile {
    bottom: var(--mobile-menu-height);
  }

  .c-toast-container {
    margin-bottom: var(--s3);
    position: relative;
  }
</style>
